import React, { useState } from "react";
import Sidebar from "../../Component/Sidebar/Sidebar";
import Header from "../../Component/Header/Header";
import RepresentativeDeliveryStats from "./RepresentativeDeliveryStats";
import RepresentativeDeliveryRange from "./RepresentativeDeliveryRange";
import "./RepresentativeCommission.css";
import {  FiUser, FiSearch } from "react-icons/fi";

const RepresentativeCommission = () => {
  const [activeTab, setActiveTab] = useState("search");

  return (
    <div className="representative-commission-page">

      {/* ================= SIDEBAR ================= */}
      <div className="representative-commission-sidebar">
        <Sidebar />
      </div>

      {/* ================= BODY ================= */}
      <div className="representative-commission-body">

        {/* ================= HEADER ================= */}
        <div className="representative-commission-header">
          <Header />
        </div>

        {/* ================= MAIN ================= */}
        <main className="representative-commission-main">

          <div className="representative-commission-container">

            {/* ================= PAGE HEADER ================= */}
            <div className="commission-page-header">
              <div>
                <h2>إحصائيات المندوبين</h2>

                <p>
                  البحث عن المندوبين ومتابعة نسب التسليم
                </p>
              </div>
            </div>

            {/* ================= TABS ================= */}
            <div className="commission-tabs">

              <button
                type="button"
                className={`commission-tab ${
                  activeTab === "search" ? "active" : ""
                }`}
                onClick={() => setActiveTab("search")}
              >
                <span className="commission-tab-icon">
                  <FiUser size={17} />
                </span>

                <span>البحث عن مندوب</span>
              </button>

              <button
                type="button"
                className={`commission-tab ${
                  activeTab === "range" ? "active" : ""
                }`}
                onClick={() => setActiveTab("range")}
              >
                <span className="commission-tab-icon">
                  <FiSearch size={17} />
                </span>

                <span>نسبة التسليم</span>
              </button>

            </div>

            {/* ================= TAB CONTENT ================= */}
            <div className="commission-tab-content">

              {activeTab === "search" && (
                <RepresentativeDeliveryStats />
              )}

              {activeTab === "range" && (
                <RepresentativeDeliveryRange />
              )}

            </div>

          </div>

        </main>
      </div>
    </div>
  );
};

export default RepresentativeCommission;